import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from 'shell-models-lib';
import { Metamodel } from 'app/model/base/model';
import { SybaseTableDataset } from 'app/model/dataset/sybase-table.dataset';
import { TabularTypeDatasetAdapter, tabularTypeDatasetAdapts } from './tabular-type.dataset.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SybaseTableDataset),
    asynchronous: true,
    adapts: tabularTypeDatasetAdapts
})
export class SybaseTableDatasetAdapter extends TabularTypeDatasetAdapter<SybaseTableDataset, Model.DatasetResource> {
    protected async _toResource(dataset: SybaseTableDataset): Promise<Model.DatasetResource> {
        return this._toResourceInternal(dataset, Metamodel.modelFor(SybaseTableDataset).name);
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: SybaseTableDataset): Promise<SybaseTableDataset> {
        return await this._toModelInternal(modelDatasetResource, dataset, SybaseTableDataset.MODEL);
    }
}
